const Dashboard = () => {
  return (
      <div className="page-content">
          <h4>Dashboard</h4>
      </div>
  );
};

export default Dashboard;